<template>
<div>
  <div class="card printhide">
    <div class="inset clearfix">
      <button
        v-if="
          !$parent.port
          && currentGoalOffersSelected.length < 1
          && $parent.status == 'Bezig'
        "
        class="secondary setting"
        @click="$parent.intake.goalData.step=1"
      >
        <awesomeIcon icon="edit"/> Doel wijzigen
      </button>

      <h2 class="title">
        <awesomeIcon icon="fa-regular fa-circle-dot"/>
        <template v-if="$parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'">Doel</template>
        <template v-else>
          {{$parent.getGoalType()}} {{$parent.name ? $parent.name : ''}}
        </template>
      </h2>

      <div
        v-if="!$parent.redo && $parent.isOfferGoal"
        style="margin-bottom:10px;"
      >
        {{filter($parent.intake.offers, (o) => o.selected).length === 0
          ? `U kunt hier de opgevraagde indicatie(s) bekijken en bij akkoord accepteren. Hierna komt
            u terecht in onze online vragenlijst.`
          : `U kunt hier uw geaccepteerde indicatie bekijken. Door op
            ${$parent.intake.started ? `'Volgende'` : `'Start vragenlijst'`} te klikken
            komt u terecht in onze online vragenlijst.`
        }}
        Aan de hand van uw persoonlijke doel, financiële situatie en risicobereidheid
        zullen wij voor u een beleggingsplan opstellen en uw beleggingsrekening openen.
      </div>

      <div class="msg" v-if="$parent.isOfferGoal && $parent.redo && $parent.role < 7">
        Uw uitkering is gestart en kunt u niet zonder overleg met ons wijzigen.
      </div>

      <!-- Doelbeleggen -->
      <template v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'">

        <!-- Offers -->
        <div
          v-if="$parent.isOfferGoal && (!$parent.redo || $parent.role > 7)"
          class="offer-container"
        >
          <div
            v-for="(offer, index) in (
              currentGoalOffersSelected.length == 1 ?
              currentGoalOffersSelected : currentGoalOffers
            )" :key="index"
          >
            <div :class="['offer', offer.selected ? 'selected' : '']">
              <div class="offer-box">
                <h2 style="margin-top:0;">
                  Indicatie {{ offerTypeName(offer.offerType) }}
                  <awesomeIcon v-if="offer.selected" icon="check"/>
                </h2>
                <template v-if="Number($parent.role) !== 2">
                  <i class="status-text" v-if="
                    !$parent.intakeAdmin.offers[offer.offerId]
                    || !$parent.intakeAdmin.offers[offer.offerId].approved
                  ">
                    <br>&hellip; wij zijn bezig met het opstellen van uw indicatie.
                  </i>
                </template>
                <template v-if="offer.selected">
                  <br>U heeft een kapitaal opgebouwd voor uw oude dag. Dit kapitaal gaat u gebruiken
                  voor een periodieke uitkering. U heeft gekozen om uw kapitaal te gaan beleggen.
                  Met beleggen kan uw kapitaal hoger worden. Maar ook lager. Uw kapitaal en
                  uitkering zullen hoogstwaarschijnlijk ieder jaar anders zijn. Bedenk dus goed
                  wat u wilt.<br>
                </template>
                <i class="msg status-text" style="margin-top:10px;" v-if="
                  $parent.intakeAdmin.offers[offer.offerId]
                  && $parent.intakeAdmin.offers[offer.offerId].note
                ">
                  {{ $parent.intakeAdmin.offers[offer.offerId].note }}
                </i>
                <span class="date faded">
                  {{new Date(offer.offerDate).toLocaleDateString()}}
                </span>
                <br>
                Inleg &euro; {{formatPrice(Number(offer.vermogen), true)}},-<br>
                <template v-if="offer.doelAanvulling">
                  Vaste uitkering &euro;&nbsp;{{formatPrice(offer.doelAanvulling, true)}},-
                  per jaar.<br>
                </template>
                <template v-else>
                  Looptijd {{offer.looptijd}} jaar.<br>
                </template>
                <template v-if="
                  $parent.intakeAdmin.offers[offer.offerId]
                  && $parent.intakeAdmin.offers[offer.offerId].calculated
                ">
                  <template v-if="offer.offerType != 3">
                  Eerste jaaruitkering is
                  {{ offer.offerType == 4 || offer.offerType == 5 ? '' : '(bruto)' }}
                  &euro;&nbsp;{{
                    formatPrice(
                      Number(
                        offer.offerType == 1 || offer.offerType == 4
                        ? $parent.intakeAdmin.offers[offer.offerId].calculation.charts.chart2[0][2]
                        : offer.offerType != 0 && offer.offerType != 5
                        ? $parent.intakeAdmin.offers[offer.offerId].calculation.charts.chart1[0][2]
                        : $parent.intakeAdmin.offers[offer.offerId].calculation.charts.chart2[0][1]
                      ),
                      true,
                    )
                  }},-<br>
                  </template>
                  <template v-if="offer.offerType == 3">
                    Indicatie looptijd circa
                    {{ formatPrice(Number(
                      $parent.intakeAdmin.offers[offer.offerId].calculation.looptijd.huidigprofiel
                    ), true) }} jaar.<br>
                  </template>
                  Voorbeeld rendement {{ $parent.intakeAdmin.offers[offer.offerId].profile }}%<br>
                  <template v-if="offer.offerType != 2 && offer.offerType != 3">
                    U-rendement {{ $parent.intakeAdmin.offers[offer.offerId].urendement }}%<br>
                  </template>
                </template>
                Uitbetaling {{offer.stortingenInterval.toLowerCase()}}.
                <template v-if="
                  offer.nextOfKin === 'true'
                ">
                  <br>Dit is een nabestaanderekening.
                </template>
                <div class="menu">
                  <button
                    v-if="!offer.selected"
                    class="remove btn tertiary"
                    @click="!$parent.writeModus ? modusAlert() : deleteOffer(offer.offerId);"
                  >
                    Verwijderen
                  </button>

                  <button
                    v-if="offer.selected && ($parent.redo == 0 || $parent.role > 7)"
                    class="cancel-offer btn tertiary"
                    @click="deSelectOffer(offer.offerId)"
                  >
                    Annuleren {{ $parent.role > 7 && $parent.redo == 1 ? '(admin)' : ''}}
                  </button>
                  <button
                    v-if="Number($parent.role) > 7 && !offer.selected"
                    :class="['calc-offer', 'btn', 'tertiary', 'hide-mobile']"
                    @click="!$parent.writeModus ? modusAlert() : createAdminOffer(offer.offerId)"
                  >
                    Bereken (admin)
                  </button>
                  <button
                    v-if="
                      $parent.intakeAdmin.offers[offer.offerId]
                      && $parent.intakeAdmin.offers[offer.offerId].approved
                    "
                    :class="['view-offer', 'btn', offer.selected ? 'tertiary' : '']"
                    @click="offerAdminIndex=offer.offerId;offerUserModal=true;"
                  >
                    Bekijken
                  </button>
                </div>
              </div>
              <div class="inputbox text" v-if="
                $parent.role > 7 && currentGoalOffersSelected.length == 1 && $parent.redo
              ">
                <button @click="writePayouts()">Potjes (eenmalig!)</button>
              </div>
            </div>
          </div>
          <div class="empty" v-if="
            currentGoalOffers.length < maxOffertes
            && currentGoalOffersSelected.length < 1
            && ($parent.redo == 0 || $parent.role > 7)"
          >
            <button class="secondary" @click="indicatieModal=true;errorText='';">
              Indicatie {{Number($parent.role) === 2 ? 'berekenen': 'aanvragen'}}
              <!-- max. {{maxOffertes - currentGoalOffers.length}}) -->
              <awesomeIcon icon="plus"/>
            </button>
          </div>
        </div>

        <!-- Fake offer -->
        <template v-else-if="false">
          <div
            v-for="(offer, index) in filter(currentGoalOffers, 'selected')"
            :key="index"
          >
            <h2>
              Voorbeeld Indicatie {{ offerTypeName(offer.offerType) }}
            </h2>
            <span class="date faded">
              {{new Date(offer.offerDate).toLocaleDateString()}}
            </span>
            <br>
            Inleg &euro; {{formatPrice(Number(offer.vermogen), true)}}<br>
            Looptijd {{offer.looptijd}} jaar<br>
            Uitbetaling {{offer.stortingenInterval.toLowerCase()}}
            <br><br>
            <i class="faded status-text">
              U heeft een kapitaal opgebouwd voor uw oude dag. Dit kapitaal gaat u gebruiken
              voor een periodieke uitkering. U heeft gekozen om uw kapitaal te gaan beleggen.
              Met beleggen kan uw kapitaal hoger worden. Maar ook lager. Uw kapitaal en
              uitkering zullen hoogstwaarschijnlijk ieder jaar anders zijn. Bedenk dus goed
              wat u wilt.
            </i>
            <i class="faded status-text" v-if="
              $parent.intakeAdmin.offers[offer.offerId]
              && $parent.intakeAdmin.offers[offer.offerId].note
            ">
              <br>{{ $parent.intakeAdmin.offers[offer.offerId].note }}
            </i>
            <button
              class="view-offer btn"
              @click="offerAdminIndex=offer.offerId;offerUserModal=true;"
            >
              Bekijken
            </button>
          </div>
        </template>

        <!-- Leefrente / Netto lijfrente uitkerend -->
        <modalWindow
          v-if="
            (
              (modelValue.type=='levensonderhoud' && Number(modelValue.box) == 1)
              || modelValue.type=='netto-lijfrente-uitkerend'
            )
            && indicatieModal
          "
          @close="indicatieModal=false"
          width="350"
        >
          <div class="titlebar">
            Indicatie {{Number($parent.role) === 2 ? 'berekenen': 'aanvragen'}}
          </div>
          <div class="inset">
            <div
              v-if="
                modelValue.offerType === '1'
                && Number(modelValue.looptijd) >= 20
              "
              class="row form-error-atp warning"
            >
            <b>Let op:</b> Indicatie type 'Hoge aanvang' in combinatie met een looptijd van
            minimaal 20 jaar, bevat altijd tijdelijke lijfrentes.<br /><br />
            Daarom kan deze combinatie niet worden aangeboden voordat de AOW leeftijd is bereikt
            en/of voor sommige nabestaanden.
            </div>
            <div
              v-if="errorText"
              class="row form-error-atp"
            >
              <awesomeIcon icon="exclamation-circle" size="lg" style="margin-right: 10px;" />
              <b>Indicatie mislukt</b>
              <br /><br /><span v-html="errorText" />
            </div>
            <customInput
              v-model="modelValue.offerType" :validation="['notrequired']"
              type="dropdown" label="Indicatie type" :options="[
                {
                  label: 'Hoge aanvang',
                  value: modelValue.type=='netto-lijfrente-uitkerend' ? '4' : '1',
                  default: true,
                },
                {
                  label:'Normale aanvang',
                  value: modelValue.type=='netto-lijfrente-uitkerend' ? '5' : '0',
                },
              ]"
            />
            <customInput
              ref="focus"
              v-model="modelValue.vermogen" type="money"
              :label="'Eenmalige inleg (minimaal € 5000,-)'" :min="5000"
              :validation="['min']"
            />
            <customInput
              v-model="modelValue.looptijd" :max="40" :step="1"
              type="number" label="Looptijd uitkering in jaren"
              :min="modelValue.offerType == '4' || modelValue.offerType == '1' ? 6 : 5"
              :validation="['min', 'max']"
            />
            <customInput
              v-model="modelValue.nextOfKin"
              type="dropdown" label="Nabestaanderekening" :options="[
                { label: 'Ja', value: 'true' },
                { label: 'Nee', value: 'false', default: true },
              ]"
            />
            <customInput
              v-model="modelValue.stortingenInterval"
              type="dropdown" label="Uitbetalingsinterval" :options="[
                { label:'Per maand', value:'Per maand' },
                { label:'Per kwartaal', value:'Per kwartaal' },
                { label:'Per halfjaar', value:'Per halfjaar' },
                { label:'Per jaar', value:'Per jaar' },
              ]"
            />
            <button @click="createOffer()">
              Indicatie {{Number($parent.role) === 2 ? 'berekenen': 'aanvragen'}}
            </button>
          </div>
        </modalWindow>

        <!-- Goudenhanddruk uitkerend -->
        <modalWindow
          v-if="
            modelValue.type=='gouden-handdruk-uitkerend'
            && indicatieModal
          "
          @close="indicatieModal=false" width="350"
        >
          <div class="titlebar">
            Indicatie {{Number($parent.role) === 2 ? 'berekenen': 'aanvragen'}}
          </div>
          <div class="inset">
            <div
              v-if="errorText"
              class="row form-error-atp"
            >
              <awesomeIcon icon="exclamation-circle" size="lg" style="margin-right: 10px;" />
              <b>Indicatie mislukt</b>
              <br /><br /><span v-html="errorText" />
            </div>
            <customInput
              v-model="modelValue.offerType"
              type="dropdown" label="Indicatie type" :options="[
                {label:'Vaste looptijd', value:'2', default: true,},
                {label:'Vaste uitkering', value:'3'},
              ]"
            />
            <customInput
              ref="focus"
              v-model="modelValue.vermogen" type="money"
              :label="'Eenmalige inleg (minimaal € 5000,-)'" :min="5000"
              :validation="['min']"
            />
            <customInput
              v-if="modelValue.offerType == 2"
              v-model="modelValue.looptijd"
              type="number" label="Looptijd uitkering in jaren"
              :min="5" :max="40" :step="1"
              :validation="['min', 'max']"
            />
            <customInput
              v-else
              v-model="modelValue.doelAanvulling"
              type="money" label="Aanvullingsbedrag per jaar" :key="'Aanvullingsbedrag'"
            />
            <customInput
              v-model="modelValue.nextOfKin"
              type="dropdown" label="Nabestaanderekening" :options="[
                { label: 'Ja', value: 'true' },
                { label: 'Nee', value: 'false', default: true },
              ]"
            />
            <customInput
              v-model="modelValue.stortingenInterval"
              type="dropdown" label="Uitbetalingsinterval" :options="[
                {label:'Per maand', value:'Per maand'},
                {label:'Per kwartaal', value:'Per kwartaal'},
                {label:'Per halfjaar', value:'Per halfjaar'},
                {label:'Per jaar', value:'Per jaar'},
              ]"
            />
            <button @click="createOffer()">
              Indicatie {{Number($parent.role) === 2 ? 'berekenen': 'aanvragen'}}
            </button>
          </div>
        </modalWindow>

        <!-- Doelbeleggen goals-->
        <div v-if="!$parent.isOfferGoal" class="flex-container">
          <div class="goal-inputs flex-50">

            <div class="subheader" v-if="$parent.redo">
              Huidige waarde <b>&euro; {{formatPrice(Number($parent.portValue), true)}}</b>
            </div>

            <!-- Pensioen -->
            <template
              v-if="modelValue.type=='pensioen'
              || modelValue.type=='gouden-handdruk-opbouwend'
              || modelValue.type=='netto-lijfrente-opbouwend'"
            >
              <customInput
                v-if="!$parent.redo"
                ref="focus"
                v-model="modelValue.vermogen" type="money"
                :label="'Eenmalige inleg (minimaal € '+startBedrag+',-)'" :min="startBedrag"
                :validation="['min']"
              />
              <customInput
                v-else
                ref="focus"
                v-model="modelValue.vermogen" type="money"
                :label="'Extra eenmalige inleg'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="$parent.redo" v-model="modelValue.stortingenInterval"
                type="dropdown" label="Interval inleg" :options="[
                  {label:'Per maand', value:'Per maand'},
                  {label:'Per kwartaal', value:'Per kwartaal'},
                  {label:'Per jaar', value:'Per jaar'},
                ]"
              />
              <customInput
                v-if="modelValue.type !=='gouden-handdruk-opbouwend'"
                v-model="modelValue.stortingenBedrag"
                type="money" :label="!$parent.redo ? 'Inleg per maand' : 'Periodieke inleg'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.leeftijd"
                type="number" label="Uw leeftijd"
                :min="16" :max="100" :step="1"
                :validation="['min', 'max']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.pensioenLeeftijd"
                type="number"
                label="Pensioenleeftijd"
                :min="returnMinPensionAge"
                :max="modelValue.box == '3' ? 100 : 90" :step="1"
                :validation="['min', 'max']"
              />
              <customInput
                v-else
                v-model="modelValue.targetDate"
                type="date" label="Eerste uitkering"
                :minDatetime="new Date()"
                :maxDatetime="new Date(
                    (new Date()
                  ).setFullYear((new Date()).getFullYear() + 60))
                "
                :validation="['min', 'max']"
              />
              <div
                class="msg"
                style="display:block;"
                v-if="modelValue.box === '1'"
              >
                <awesomeIcon icon="exclamation-circle"/>
                {{
                  `Het is belangrijk dat u vóór de uitkeerdatum (uiterlijk AOW leeftijd
                  ${modelValue.type === 'gouden-handdruk-opbouwend' ? '' : ' + 5 jaar' })
                  contact met ons opneemt. We bekijken dan opnieuw uw situatie en stellen een
                  uitkeerschema voor u op. Pas als u daarmee instemt, kunnen we starten met
                  uitkeren.`
                }}
              </div>
              <customInput
                v-if="
                  (modelValue.type == 'pensioen' || modelValue.type == 'levensonderhoud')
                  && !$parent.port
                  && filter($parent.intake.persoonsData, $parent.financeFilter).length <= 1
                "
                class="align-left small"
                type="yesno"
                label="Fiscaal regime"
                v-model="modelValue.box"
                :options="[
                  {label:'Bruto / lijfrente (box 1)', value: '1'},
                  {label:'Netto beleggen (box 3)', value: '3'},
                ]"
              />
              <customInput
                v-model="modelValue.uitkeringsPeriode"
                type="number" label="Uitkeringsperiode in jaren"
                :min="1" :max="40" :step="1"
                :validation="['min', 'max']"
              />
              <customInput
                @clicked="openModal('pensioenLeeftijdModal')"
                :focusOverwrite="pensioenLeeftijdModal"
                v-model="modelValue.doelAanvulling" :readonly="true"
                type="money" label="Pensioenaanvulling per maand"
              />
              <div class="msg" style="display:block;">
                <awesomeIcon icon="exclamation-circle"/> Doelvermogen
                <b> &euro; {{formatPrice(Number(modelValue.doel), true)}},-</b>
              </div>
              <!-- Aanvulling popup -->
              <modalWindow
                v-show="pensioenLeeftijdModal"
                @close="pensioenLeeftijdModal=false"
                :bgtrigger="false"
              >
                <div class="titlebar">Pensioenaanvulling</div>
                <div class="form-notice">
                  <awesomeIcon icon="exclamation-circle"/>
                  Klik <u style="cursor:pointer;" @click="berekenAanvulling">hier</u>
                  om onze suggestie in te vullen.
                </div>
                <customInput
                  ref="fakeInputFocus"
                  v-model="modelValue.doelAanvulling"
                  type="money" label="Pensioenaanvulling per maand"
                  :validation="['notrequired']"
                />
                <div class="inset">
                  <button @click="pensioenLeeftijdModal=false">
                    Accepteren
                  </button>
                </div>
              </modalWindow>
            </template>

            <!-- Vermogensopbouw -->
            <template v-else-if="modelValue.type=='vermogensopbouw'">
              <customInput
                v-if="!$parent.redo"
                ref="focus"
                v-model="modelValue.vermogen"
                type="money"
                :label="`Startbedrag (minimaal € ${formatPrice(startBedrag, true)},-)`"
                :min="startBedrag"
                :validation="['min']"
              />
              <customInput
                v-else
                ref="focus"
                v-model="modelValue.vermogen" type="money"
                :label="'Extra eenmalige inleg'" :validation="['notrequired']"
              />
              <customInput
                v-if="$parent.redo" v-model="modelValue.stortingenInterval"
                type="dropdown" label="Interval stortingen" :options="[
                  {label:'Per maand', value:'Per maand'},
                  {label:'Per kwartaal', value:'Per kwartaal'},
                  {label:'Per jaar', value:'Per jaar'},
                ]"
              />
              <customInput
                v-model="modelValue.stortingenBedrag"
                type="money" :label="!$parent.redo ? 'Storting per maand' : 'Periodieke storting'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.looptijd"
                type="number" name="jaar" label="Looptijd in jaren"
                :min="1" :max="50" :step="1" unitType="date"
                :validation="['min', 'max']"
              />
              <customInput
                v-else
                v-model="modelValue.targetDate"
                type="date" label="Doeldatum"
                :minDatetime="new Date()"
                :maxDatetime="new Date(
                    (new Date()
                  ).setFullYear((new Date()).getFullYear() + 60))
                "
                :validation="['min', 'max']"
              />
              <customInput
                :modelValue="rendCalc"
                @clicked="openModal('bereken')" :readonly="true" :focusOverwrite="berekenModal"
                type="percentage" name="jaar" label="Streefrendement"
              />
              <div class="msg" style="display:block;">
                <awesomeIcon icon="exclamation-circle"/> Doelvermogen
                <b> &euro; {{formatPrice(berekenVermogensopbouw(), true)}},-</b>
              </div>
              <!-- Doelvermogen popup -->
              <modalWindow v-if="berekenModal" @close="berekenModal=false" width="350">
                <div class="titlebar">Doelvermogen berekenen</div>
                <div class="inset">
                  {{`U gaat ${
                    modelValue.targetDate
                      ? `tot ${(new Date(modelValue.targetDate)).toLocaleDateString()}`
                      :`${modelValue.looptijd} jaar`
                    } beleggen met een inleg van &euro;&nbsp;${
                      formatPrice(Number(modelValue.vermogen), true)
                    } en een maandelijkse storting van &euro;&nbsp;${
                      formatPrice(Number(modelValue.stortingenBedrag), true)
                    }.`
                  }}
                  Over uw uiteindelijke vermogen betaalt u elk jaar rendementsheffing en inflatie.
                  Wilt u deze lasten meenemen in uw doelvermogen?
                </div>
                <customInput
                  v-model="modelValue.inflatie" type="yesno"
                  :label="'2% inflatie'"
                />
                <customInput
                  v-model="modelValue.vermogensbelasting"  type="yesno"
                  :label="'1,2% rendementsheffing'"
                />
                <customInput
                  v-model="modelValue.extrarendement" type="percentage"
                  label="Wat wilt u aan extra rendement?"
                  :validation="['notrequired']" ref="fakeInputFocus"
                />
                <form @submit.prevent class="inset">
                  Streefrendement <b>{{formatPrice(
                    (Number(modelValue.extrarendement) / 100)
                    + (modelValue.vermogensbelasting == 'Yes' ? 1.2 : 0)
                    + (modelValue.inflatie == 'Yes' ? 2 : 0),
                    false, 2)}}%</b>
                  <br>
                  Doelvermogen
                  <b> &euro; {{formatPrice(berekenVermogensopbouw(), true)}},-</b>
                  <button @click="berekenModal=false">
                    Doelvermogen invullen
                  </button>
                </form>
              </modalWindow>
            </template>

            <!-- Studie kinderen -->
            <template v-else-if="modelValue.type=='studiekinderen'">
              <customInput
                v-if="!$parent.redo"
                ref="focus"
                v-model="modelValue.vermogen"
                type="money"
                :label="'Startbedrag (minimaal € '+startBedrag+',-)'"
                :min="startBedrag"
                :validation="['min']"
              />
              <customInput
                v-else
                ref="focus"
                v-model="modelValue.vermogen"
                type="money"
                :label="'Extra eenmalige inleg'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="$parent.redo" v-model="modelValue.stortingenInterval"
                type="dropdown" label="Interval stortingen" :options="[
                  {label:'Per maand', value:'Per maand'},
                  {label:'Per kwartaal', value:'Per kwartaal'},
                  {label:'Per jaar', value:'Per jaar'},
                ]"
              />
              <customInput
                v-model="modelValue.stortingenBedrag"
                type="money" :label="!$parent.redo ? 'Storting per maand' : 'Periodieke storting'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.leeftijdKind"
                type="number" :label="`Leeftijd kind`"
                :min="0" :max="Math.min(Number(modelValue.leeftijdKindTot) - 1, 79)"
                :step="1" :validation="['notrequired', 'min', 'max']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.leeftijdKindTot"
                type="number"
                :label="`Beleggen tot leeftijd (looptijd ${Number(modelValue.looptijd)} jaar)`"
                :min="Math.min(Number(modelValue.leeftijdKind) + 1, 80)" :max="80"
                :step="1" :validation="['notrequired', 'min', 'max']"
              />
              <customInput
                v-else
                v-model="modelValue.targetDate"
                type="date" label="Doeldatum"
                :minDatetime="new Date()"
                :maxDatetime="new Date((
                    new Date()
                  ).setFullYear((new Date()).getFullYear() + 60))
                "
                :validation="['min', 'max']"
              />
              <customInput
                :modelValue="modelValue.doel"
                type="money" label="Doelvermogen" @clicked="openModal('studieDoel')"
                :focusOverwrite="studiedoelModal" :readonly="true"
              />
              <!-- studiedoel popup -->
              <modalWindow v-show="studiedoelModal" @close="studiedoelModal=false">
                <div class="titlebar">Doelvermogen</div>
                <div class="form-notice">
                  <awesomeIcon icon="exclamation-circle"/>
                  Klik <u style="cursor:pointer;" @click="berekenAanvulling">hier</u>
                  om onze suggestie in te vullen.
                </div>
                <customInput
                  ref="fakeInputFocus"
                  v-model="modelValue.doel"
                  type="money" label="Doelvermogen"
                  :max="2000000000" :validation="['max']"
                />
                <div class="inset">
                  <button @click="studiedoelModal=false">
                    Accepteren
                  </button>
                </div>
              </modalWindow>
            </template>

            <!-- Hypotheek -->
            <template v-else-if="modelValue.type=='hypotheek'">
              <customInput
                ref="focus"
                v-if="!$parent.redo" v-model="modelValue.vermogen"
                type="money"
                :label="'Startbedrag (minimaal € '+startBedrag+',-)'" :min="startBedrag"
                :validation="['min']"
              />
              <customInput
                ref="focus"
                v-else v-model="modelValue.vermogen" type="money"
                :label="'Extra eenmalige inleg'" :validation="['notrequired']"
              />
              <customInput
                v-if="$parent.redo" v-model="modelValue.stortingenInterval"
                type="dropdown" label="Interval stortingen" :options="[
                  {label:'Per maand', value:'Per maand'},
                  {label:'Per kwartaal', value:'Per kwartaal'},
                  {label:'Per jaar', value:'Per jaar'},
                ]"
              />
              <customInput
                v-model="modelValue.stortingenBedrag"
                type="money" :label="!$parent.redo ? 'Storting per maand' : 'Periodieke storting'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.looptijd"
                type="number" name="" label="Jaren tot aflossing"
                :min="1" :max="50" :step="1"
                :validation="['min', 'max']"
              />
              <customInput
                v-else
                v-model="modelValue.targetDate"
                type="date" label="Aflosdatum"
                :minDatetime="new Date()"
                :maxDatetime="new Date((
                    new Date()
                  ).setFullYear((new Date()).getFullYear() + 60))
                "
                :validation="['min', 'max']"
              />
              <customInput
                v-model="modelValue.doel"
                type="money" label="Af te lossen bedrag"
                :max="2000000000" :validation="['max']"
              />
            </template>

            <!-- Levensonderhoud -->
            <template v-else-if="modelValue.type=='levensonderhoud'">
              <customInput
                ref="focus"
                v-if="!$parent.redo" v-model="modelValue.vermogen"
                type="money"
                :label="'Startbedrag (minimaal € '+startBedrag+',-)'" :min="startBedrag"
                :validation="['min']"
              />
              <customInput
                ref="focus"
                v-else v-model="modelValue.vermogen" type="money"
                :label="'Extra eenmalige inleg'" :validation="['notrequired']"
              />
              <customInput
                v-if="$parent.redo" v-model="modelValue.stortingenInterval"
                type="dropdown" label="Interval stortingen" :options="[
                  {label:'Per maand', value:'Per maand'},
                  {label:'Per kwartaal', value:'Per kwartaal'},
                  {label:'Per jaar', value:'Per jaar'},
                ]"
              />
              <customInput
                v-model="modelValue.doelAanvulling"
                type="money"
                :label="
                  $parent.redo
                    ? 'Aanvullingsbedrag'
                    : 'Aanvullingsbedrag per maand'
                "
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.looptijd"
                type="number" label="Looptijd in jaren"
                :min="1" :max="50" :step="1"
                :validation="['min', 'max']"
              />
              <customInput
                v-else
                v-model="modelValue.targetDate"
                type="date" label="Doeldatum"
                :minDatetime="new Date()"
                :maxDatetime="new Date((
                    new Date()
                  ).setFullYear((new Date()).getFullYear() + 60))
                "
                :validation="['min', 'max']"
              />
            </template>

            <!-- Algemeen -->
            <template v-else>
              <customInput
                ref="focus"
                v-if="!$parent.redo" v-model="modelValue.vermogen"
                type="money"
                :label="'Startbedrag (minimaal € '+startBedrag+',-)'" :min="startBedrag"
                :validation="['min']"
              />
              <customInput
                ref="focus"
                v-else v-model="modelValue.vermogen" type="money"
                :label="'Extra eenmalige inleg'" :validation="['notrequired']"
              />
              <customInput
                v-if="$parent.redo" v-model="modelValue.stortingenInterval"
                type="dropdown" label="Interval stortingen" :options="[
                  {label:'Per maand', value:'Per maand'},
                  {label:'Per kwartaal', value:'Per kwartaal'},
                  {label:'Per jaar', value:'Per jaar'},
                ]"
              />
              <customInput
                v-model="modelValue.stortingenBedrag"
                type="money" :label="!$parent.redo ? 'Storting per maand' : 'Periodieke storting'"
                :validation="['notrequired']"
              />
              <customInput
                v-if="!modelValue.targetDate && !$parent.redo"
                v-model="modelValue.looptijd"
                type="number" label="Looptijd in jaren"
                :min="1" :max="50" :step="1"
                :validation="['min', 'max']"
              />
              <customInput
                v-else
                v-model="modelValue.targetDate"
                type="date" label="Aankoopdatum"
                :minDatetime="new Date()"
                :maxDatetime="new Date((
                    new Date()
                  ).setFullYear((new Date()).getFullYear() + 60))
                "
                :validation="['min', 'max']"
              />
              <customInput
                v-model="modelValue.doel"
                type="money" label="Doelvermogen"
                :max="2000000000" :validation="['max']"
              />
            </template>

          </div>

          <!-- Meter -->
          <div
            v-if="!$parent.isOfferGoal"
            class="info-button"
            style="padding:0px 6%;"
            @click="meterModal=true"
          >
            <div
              v-if="modelValue.score > 0"
              style="text-align:center; margin-top:10px; margin-bottom:20px;"
            >
              <awesomeIcon icon="question-circle"/>
              Profiel {{
                this.$parent.intakeAdmin.beleggen.profile
                || $parent.fromSatProfile(modelValue.optimalProfile)
              }}
            </div>
            <scoreWidget v-model="modelValue.score" />
          </div>

          <!-- Offers -->
          <div
          v-if="$parent.isOfferGoal && (!$parent.redo || $parent.role > 7)"
          :class="['offer-container', currentGoalOffers.length == 0 ? 'empty' : '']"
        >
          <div
            v-for="(offer, index) in (
              currentGoalOffersSelected.length == 1 ?
              currentGoalOffersSelected : currentGoalOffers)
            "
            :key="index"
          >
            <div
              :class="['offer', offer.selected ? 'selected' : '']"
            >
              <div
                :class="[
                  'offer-box',
                  $parent.intakeAdmin.offers[offer.offerId]
                  && $parent.intakeAdmin.offers[offer.offerId].approved ? 'approved' : ''
                ]"
              >
                <h2 v-if="offer.selected">
                  Indicatie {{ offerTypeName(offer.offerType) }}
                </h2>
                <b v-if="!offer.selected">
                  Indicatie #{{ offer.offerId }} {{ offerTypeName(offer.offerType) }}
                </b>
                <span class="date faded">
                  {{new Date(offer.offerDate).toLocaleDateString()}}
                </span>
                <br>
                Inleg &euro; {{formatPrice(Number(offer.vermogen), true)}},-<br>
                <template v-if="offer.doelAanvulling">
                   Vaste uitkering &euro;&nbsp;{{formatPrice(offer.doelAanvulling, true)}},-
                   per jaar<br />
                </template>
                <template v-else>
                   Looptijd {{offer.looptijd}} jaar<br>
                </template>
                Uitbetaling {{offer.stortingenInterval.toLowerCase()}}
                <br><br>
                <i class="faded status-text" v-if="offer.selected">
                  U heeft een kapitaal opgebouwd voor uw oude dag. Dit kapitaal gaat u gebruiken
                  voor een periodieke uitkering. U heeft gekozen om uw kapitaal te gaan beleggen.
                  Met beleggen kan uw kapitaal hoger worden. Maar ook lager. Uw kapitaal en
                  uitkering zullen hoogstwaarschijnlijk ieder jaar anders zijn. Bedenk dus goed
                  wat u wilt.
                </i>

                <!-- {{`&euro; ${formatPrice(
                    Number(offer.offerType == 1 || offer.offerType == 4
                      ? charts.chart2[0][2]
                      : offer.offerType == 2
                        ? offer.charts.chart1[0][2]
                        : offer.charts.chart2[0][1],
                    ) / 12,
                    true,
                  )}- per maand`
                }} -->

                <i class="faded status-text" v-if="
                  !$parent.intakeAdmin.offers[offer.offerId]
                  || !$parent.intakeAdmin.offers[offer.offerId].approved
                ">
                  &hellip; wij zijn bezig met het opstellen van uw indicatie.
                </i>
                <i class="faded status-text" v-if="
                  $parent.intakeAdmin.offers[offer.offerId]
                  && $parent.intakeAdmin.offers[offer.offerId].note
                ">
                  <br>{{ $parent.intakeAdmin.offers[offer.offerId].note }}
                </i>
                <span
                  v-if="!offer.selected"
                  class="remove faded"
                  @click="deleteOffer(offer.offerId);
                ">
                  <awesomeIcon icon="trash" />
                </span>
                <button
                  v-if="
                    $parent.intakeAdmin.offers[offer.offerId]
                    && $parent.intakeAdmin.offers[offer.offerId].approved
                  "
                  class="view-offer btn"
                  @click="offerAdminIndex=offer.offerId;offerUserModal=true;"
                >
                  Bekijken
                </button>
                <button
                  v-if="offer.selected && ($parent.redo == 0 || $parent.role > 7)"
                  class="cancel-offer btn secondary"
                  @click="deSelectOffer(offer.offerId)"
                >
                  Annuleren {{ $parent.role > 7 && $parent.redo == 1 ? '(admin)' : ''}}
                </button>
              </div>
              <div class="inputbox text" v-if="
                $parent.role > 7 && currentGoalOffersSelected.length == 1 && $parent.redo
              ">
                <button @click="writePayouts()">Potjes  (eenmalig!)</button>
              </div>
              <div class="admin" v-if="$parent.role > 7">
                <span @click="createAdminOffer(offer.offerId)">
                  Bereken (admin)
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="false"
        >
          <div
            v-for="(offer, index) in filter(currentGoalOffers, 'selected')"
            :key="index"
          >
            <h2>
              Voorbeeld Indicatie {{ offerTypeName(offer.offerType) }}
            </h2>
            <span class="date faded">
              {{new Date(offer.offerDate).toLocaleDateString()}}
            </span>
            <br>
            Inleg &euro; {{formatPrice(Number(offer.vermogen), true)}}<br>
            Looptijd {{offer.looptijd}} jaar<br>
            Uitbetaling {{offer.stortingenInterval.toLowerCase()}}
            <br><br>
            <i class="faded status-text">
              U heeft een kapitaal opgebouwd voor uw oude dag. Dit kapitaal gaat u gebruiken
              voor een periodieke uitkering. U heeft gekozen om uw kapitaal te gaan beleggen.
              Met beleggen kan uw kapitaal hoger worden. Maar ook lager. Uw kapitaal en
              uitkering zullen hoogstwaarschijnlijk ieder jaar anders zijn. Bedenk dus goed
              wat u wilt.
            </i>
            <i class="faded status-text" v-if="
              $parent.intakeAdmin.offers[offer.offerId]
              && $parent.intakeAdmin.offers[offer.offerId].note
            ">
              <br>{{ $parent.intakeAdmin.offers[offer.offerId].note }}
            </i>
            <button
              class="view-offer btn"
              @click="offerAdminIndex=offer.offerId;offerUserModal=true;"
            >
              Bekijken
            </button>
          </div>
        </div>

        <!-- Modal meter -->
        <modalWindow v-show="meterModal" @close="meterModal=false">
          <div class="titlebar">Profiel</div>
          <div class="inset">
            <template v-if="modelValue.score > 0">
              <template v-if="(
                this.$parent.intakeAdmin.beleggen.profile
                || $parent.fromSatProfile(modelValue.optimalProfile)
              ) == 'Doelbeleggen Sparen'">
                De Doelmeter geeft aan dat uw doel de grootste haalbaarheid heeft wanneer u
                gaat sparen.
                Uiteraard kunt u ook uw doelvermogen verhogen of de looptijd verkorten.
              </template>
              <template v-else>
              De Doelmeter geeft aan dat uw doel de grootste haalbaarheid heeft wanneer u
              gaat beleggen in Profiel {{
                this.$parent.intakeAdmin.beleggen.profile
                || $parent.fromSatProfile(modelValue.optimalProfile)
              }}.
              <a
                target="_blank"
                class="button"
                style="margin-top:20px; margin-bottom:20px;"
                href="https://www.doelbeleggen.nl/content/uploads/Beleggingsprofielen.pdf"
              >
                <awesomeIcon icon="file-alt"/>
                Beleggingsprofielen
              </a>
              </template>
            </template>
            <br /><b style="margin-bottom:5px;">Haalbaarheid</b><br>
            Hoe hoger de haalbaarheid, hoe beter.
            Zo geeft een haalbaar­heid van minder dan 50% aan dat uw doel onzekerder wordt.
            Met een haalbaar­heid van 50% en hoger bouwt u een buffer voor mindere tijden.
            <br><br>
            Om uw haalbaarheid te verhogen, kunt u de inleg verhogen en/of looptijd verlengen.
            U kunt uiteraard ook altijd bellen met onze adviseurs op 020-5550055.
          </div>
        </modalWindow>
      </div>

      </template>

      <!-- Andere merken -->
      <div v-else>
        <div class="subheader" style="margin-top:0;">
          <template v-if="modelValue.type=='vermogensopbouw'">
            Vermogensopbouw
          </template>
          <template v-if="modelValue.type=='levensonderhoud'">
            Levensonderhoud
          </template>
          <template v-if="modelValue.type=='hypotheek'">
            Hypotheek aflossen
          </template>
          <template v-if="modelValue.type=='studiekinderen'">
            Studie (klein)kinderen
          </template>
          <template v-if="modelValue.type=='groteaankoop'">
            Specifieke aankoop
          </template>
          <template v-if="modelValue.type=='pensioen'">
            Pensioen
          </template>
          <template v-if="modelValue.type=='gouden-handdruk-opbouwend'">
            Gouden handdruk (opbouwend)
          </template>
          <template v-if="modelValue.type=='gouden-handdruk-uitkerend'">
            Gouden handdruk (uitkerend)
          </template>
          <template v-if="modelValue.type=='netto-lijfrente-opbouwend'">
            Netto lijfrente (opbouwend)
          </template>
          <template v-if="modelValue.type=='netto-lijfrente-uitkerend'">
            Netto lijfrente (uitkerend)
          </template>
        </div>

        <div class="flex-container flex-grow">
          <customInput
            v-if="$parent.redo"
            :modelValue="`${$parent.portValue}`"
            type="money"
            label="Huidige waarde"
            :validation="['notrequired']"
            :disabled="true"
            class="flex-50"
          />
          <customInput
            ref="focus"
            v-if="$parent.redo"
            v-model="modelValue.vermogen"
            type="money"
            label="Extra eenmalige inleg"
            :validation="['notrequired']"
            class="flex-50"
          />
          <customInput
            ref="focus"
            v-else
            v-model="modelValue.vermogen"
            type="money"
            :label="`(minimaal € ${formatPrice(startBedrag, true)},-)`"
            :min="startBedrag"
            :validation="['min']"
          />
        </div>

        <div class="flex-container flex-grow">
          <customInput
            v-if="!modelValue.targetDate && !$parent.redo"
            v-model="modelValue.looptijd"
            type="number"
            label="Looptijd"
            :min="1" :max="50" :step="1"
            :validation="['min', 'max']"
            class="flex-50"
          />
          <customInput
            v-else
            v-model="modelValue.targetDate"
            type="date"
            label="Einddatum"
            :minDatetime="new Date()"
            :maxDatetime="new Date((
                new Date()
              ).setFullYear((new Date()).getFullYear() + 60))
            "
            :validation="['min', 'max']"
            class="flex-50"
          />
          <customInput
            ref="focus"
            v-model="modelValue.doel"
            type="money"
            label="Doelvermogen"
            class="flex-50"
          />
        </div>

        <customInput
          v-if="modelValue.looptijd < 5"
          v-model="modelValue.looptijdAccept"
          type="yesno"
          :label="`Hoe korter de beleggingsduur hoe groter het risico op verlies.
          Accepteert u dit risico?`"
        />

        <div class="subheader">Transacties</div>
        <customInput
          v-model="modelValue.stortingen"
          type="yesno" :label="'Gaat u periodieke stortingen doen?'"
        />

        <div v-if="modelValue.stortingen == 'Yes'" class="flex-container flex-grow">
          <customInput
            v-model="modelValue.stortingenInterval" type="dropdown"
              label="Periodieke Storting" :options="[
              {label:'Per maand', value:'Per maand'},
              {label:'Per kwartaal', value:'Per kwartaal'},
              {label:'Per jaar', value:'Per jaar'},
            ]"
          />
          <customInput
            v-model="modelValue.stortingenBedrag"
            type="money" label="Bedrag"
          />
        </div>
        <template v-if="
          $parent.intakeAdmin.beleggen.brand == 'VMVB'
          || $parent.intakeAdmin.beleggen.brand == 'BVS'
        ">
          <customInput
            v-model="modelValue.onttrekkingen" type="yesno"
            :label="'Gaat u periodieke onttrekkingen doen?'"
          />
          <div v-if="modelValue.onttrekkingen == 'Yes'" class="flex-container flex-grow">
            <customInput
              v-model="modelValue.onttrekkingenInterval"
              type="dropdown" label="Periodieke onttrekking" :options="[
                {label:'Per maand', value:'Per maand'},
                {label:'Per kwartaal', value:'Per kwartaal'},
                {label:'Per halfjaar', value:'Per halfjaar'},
                {label:'Per jaar', value:'Per jaar'},
              ]"
            />
            <customInput
              v-model="modelValue.onttrekkingenBedrag" type="money"
              label="Bedrag" class="flex-double"
            />
            <customInput
              v-model="modelValue.onttrekkingenStart"
              type="number"
              label="Na hoeveel jaar gaat u voor het eerst onttrekken?"
              :min="0" :max="50" :step="1" :validation="['notrequired', 'min', 'max']"
              class="flex-half"
            />
          </div>
        </template>
      </div>

      <!-- Grafiek Doelbeleggen-->
      <template v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen' && !$parent.isOfferGoal">
        <div class="chart">
          <projectWidget
            :projection="projection"
            :doel="modelValue.doel"
            :targetDate="new Date(modelValue.targetDate)"
            :looptijd="modelValue.looptijd"
          />
        </div>
        <p>
          De bovenstaande grafiek toont drie mogelijke scenario's voor het verloop van de
          beleggingswaarde:<br /><br/>
          1. Groen - rendeert beter dan verwacht<br>
          2. Blauw - rendeert volgens verwachting<br>
          3. Rood - rendeert minder dan verwacht<br>
          <template v-if="Number(modelValue.doel) !== 0">
            <br>De horizontale lijn is de doellijn
            (&euro;&nbsp;{{formatPrice(modelValue.doel, true)}},-)
          </template>
        </p>
      </template>

    </div>
  </div>

  <div
    class="footer clearfix printhide"
    v-if="!$parent.isOfferGoal || currentGoalOffersSelected.length == 1 || $parent.role == 2 "
  >
    <button
      v-if="
        (modelValue.type == 'pensioen' || modelValue.type == 'gouden-handdruk-opbouwend')
        && modelValue.box == '1'
        && ($parent.role > 7 || Number($parent.role) === 2)
      "
      @click="offerDepositModal=true"
    >
      Berekening
    </button>
    <button @click="validateGoal()" style="float:right;">
      <span v-if="$parent.redo">Opslaan </span>
      <span v-else-if="$parent.intake.started">Naar vragenlijst </span>
      <span v-else>Start vragenlijst </span>
      <awesomeIcon icon="angle-right"/>
    </button>
  </div>

  <div class="disclaimer printhide" v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'">
    De door Doelbeleggen berekende haalbaarheid van uw doel op basis van de door u ingevoerde
    gegevens betreft slechts een verwachting. Deze kan niet met zekerheid worden voorspeld. U kunt
    aan de berekende haalbaarheid dan ook geen rechten ontlenen. Het kan niet worden uitgesloten
    dat u gedurende de looptijd een extra bedrag moet inleggen om alsnog uw doel te behalen. De
    waarde van uw belegging kan fluctueren. In het verleden behaalde resultaten bieden geen
    garantie voor de toekomst. Beleggen door wie en in welke vorm dan ook brengt altijd risico's
    met zich mee. Zo kunt u (een deel van) uw ingelegde vermogen verliezen als gevolg van
    koersdalingen. Laat u goed voorlichten, zodat u zich een gedegen beeld kunt vormen van de
    risico's voordat u besluit een rekening te openen. Doelbeleggen belegt in indextrackers (ETF's)
    . Aan trackers zijn bijzondere risico's verbonden, zoals koers- , geografisch- en sectorrisico.
    Doelbeleggen is een initiatief en handelsnaam van Velthuyse • Mulder Vermogensbeheer B.V. en
    staat als beleggings&shy;onderneming geregistreerd bij de Autoriteit Financiële Markten te
    Amsterdam.
  </div>

  <!-- Modal uitkeren offer pages -->
  <modalWindow
    v-if="offerUserModal" position="full"
    @close="offerUserModal=false"
    :key="`offermodal-${offerAdminIndex}`"
  >
    <div class="viewport">
      <!-- Offer pages -->
      <offerCover
        v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
        :goalData="$parent.intake.goalData"
        :persoonsData="$parent.intake.persoonsData[0]"
        :advisor="
          Object.keys($parent.intake.advisorDetails).length > 0
            ? `
              ${$parent.intake.advisorDetails.advisor_name || ''}
              ${$parent.intake.advisorDetails.advisor_infix || ''}
              ${$parent.intake.advisorDetails.advisor_surname || ''}
            `
            : $parent.intakeAdmin.beleggen.salesName
        "
      />
      <offerGoal
        :goalData="$parent.intake.goalData"
        :vermogen="Number($parent.intake.offers[offerAdminIndex].vermogen)"
        :atpData="$parent.intake.atpData"
        :profile="offerProfile()"
        :rendement="$parent.intakeAdmin.offers[offerAdminIndex].profile"
        :persoonsData="$parent.intake.persoonsData[0]"
        :advisor="
          Object.keys($parent.intake.advisorDetails).length > 0
            ? `
              ${$parent.intake.advisorDetails.advisor_name || ''}
              ${$parent.intake.advisorDetails.advisor_infix || ''}
              ${$parent.intake.advisorDetails.advisor_surname || ''}
            `
            : $parent.intakeAdmin.beleggen.salesName
        "
        :duration="Number(durationCalc)"
        :offerType="Number($parent.intake.offers[offerAdminIndex].offerType)"
        :paymentPeriod="$parent.intake.offers[offerAdminIndex].stortingenInterval"
        :charts="$parent.intakeAdmin.offers[offerAdminIndex].calculation.charts"
      />
      <offerCourse
        v-if="Number($parent.intake.offers[offerAdminIndex].offerType) !== 3"
        :goalData="$parent.intake.goalData"
        :rendement="$parent.intakeAdmin.offers[offerAdminIndex].profile"
        :persoonsData="$parent.intake.persoonsData[0]"
        :course="$parent.intakeAdmin.offers[offerAdminIndex].calculation.verlopen"
        :offerType="Number($parent.intake.offers[offerAdminIndex].offerType)"
      />
      <offerPort
        :goalData="$parent.intake.goalData"
        :persoonsData="$parent.intake.persoonsData[0]"
        :profile="offerProfile()"
        :charts="$parent.intakeAdmin.offers[offerAdminIndex].calculation.charts"
        :offerType="Number($parent.intake.offers[offerAdminIndex].offerType)"
        :rendement="$parent.intakeAdmin.offers[offerAdminIndex].profile"
      />
      <offerCosts
        :intakeAdmin="$parent.intakeAdmin.beleggen"
        :atpData="$parent.intake.atpData"
        :goalData="$parent.intake.goalData"
        :vermogen="Number($parent.intake.offers[offerAdminIndex].vermogen)"
        :persoonsData="$parent.intake.persoonsData[0]"
        :duration="Number(durationCalc)"
        :offerType="Number($parent.intake.offers[offerAdminIndex].offerType)"
        :calculation="$parent.intakeAdmin.offers[offerAdminIndex].calculation"
        :profile="offerProfile()"
        :rendement="$parent.intakeAdmin.offers[offerAdminIndex].profile"
      />
    </div>
    <div class="printhide offer-menu">
      <button @click="offerUserModal=false;" class="tertiary">
        <awesomeIcon icon="chevron-left" /> Terug
      </button>
      <button
        v-if="
          !(`${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1)
        "
        @click="windowPrint" class="tertiary"
      >
        Printen <awesomeIcon icon="print" />
      </button>
      <button
        v-if="
          !$parent.intake.offers[offerAdminIndex].selected
          && filter($parent.intake.offers, (o) => o.selected).length === 0
        "
        @click="
          !$parent.writeModus
            ? modusAlert()
            : selectOffer(offerAdminIndex);offerUserModal=false;
        "
      >
        <!-- Indicatie #{{ offerAdminIndex }} -->
        Accepteren
        <awesomeIcon icon="chevron-right" />
      </button>
    </div>
  </modalWindow>

  <!-- Modal opbouw offer pages -->
  <modalWindow
    v-if="offerDepositModal" position="full"
    @close="offerDepositModal=false"
  >
    <div class="viewport">
      <offerCover
        v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
        :goalData="$parent.intake.goalData"
        :persoonsData="$parent.intake.persoonsData[0]"
        :advisor="
          Object.keys($parent.intake.advisorDetails).length > 0
            ? `
              ${$parent.intake.advisorDetails.advisor_name || ''}
              ${$parent.intake.advisorDetails.advisor_infix || ''}
              ${$parent.intake.advisorDetails.advisor_surname || ''}
            `
            : $parent.intakeAdmin.beleggen.salesName
        "
      />
      <offerGoal
        :goalData="$parent.intake.goalData"
        :vermogen="Number($parent.intake.goalData.vermogen)"
        :atpData="$parent.intake.atpData"
        :profile="offerProfile()"
        :persoonsData="$parent.intake.persoonsData[0]"
        :advisor="
          Object.keys($parent.intake.advisorDetails).length > 0
            ? `
              ${$parent.intake.advisorDetails.advisor_name || ''}
              ${$parent.intake.advisorDetails.advisor_infix || ''}
              ${$parent.intake.advisorDetails.advisor_surname || ''}
            `
            : $parent.intakeAdmin.beleggen.salesName
        "
      />
      <offerPort
        :goalData="$parent.intake.goalData"
        :persoonsData="$parent.intake.persoonsData[0]"
        :profile="offerProfile()"
      />
      <offerCosts
        :persoonsData="$parent.intake.persoonsData[0]"
        :vermogen="Number($parent.intake.goalData.vermogen)"
        :goalData="$parent.intake.goalData"
        :intakeAdmin="$parent.intakeAdmin.beleggen"
        :atpData="$parent.intake.atpData"
        :profile="offerProfile()"
      />
    </div>
    <div class="printhide offer-menu">
      <button @click="windowPrint" class="tertiary">
        Printen <awesomeIcon icon="print" />
      </button>
      <button @click="offerDepositModal=false">
        Start vragenlijst <awesomeIcon icon="chevron-right" />
      </button>
    </div>
  </modalWindow>

  <!-- Modal offer admin -->
  <modalWindow
    width="600"
    v-if="offerAdminModal"
    @close="offerAdminModal=false"
  >
    <div class="titlebar">Indicatie berekenen</div>
    <template v-if="!$parent.intakeAdmin.offers[offerAdminIndex].calculated">
      <div
        class="form-notice"
        v-if="
          $parent.intake.offers[offerAdminIndex].offerType !== '2'
          && $parent.intake.offers[offerAdminIndex].offerType !== '3'
        "
      >
        Zorg dat het u-rendement van deze maand klopt,
        <a target="_blank" href="https://www.pensioenperspectief.nl/kerncijfers/u-rendement/">
          <b>bekijk de actuele stand</b>
        </a>.
      </div>
      <div v-if="errorText" class="inset">
        <div class="row form-error-atp">
          <awesomeIcon icon="exclamation-circle" size="lg" style="margin-right: 10px;" />
          <b>Indicatie mislukt</b>
          <br /><br /><span v-html="errorText" />
          <button
            v-if="$parent.role > 9"
            @click="calculateOffer(offerAdminIndex, true)"
            class="tertiary"
          >
            Toch berekenen (SUPER ADMIN)
          </button>
        </div>
      </div>
      <form @submit.prevent class="inset">
        <input
          v-if="
          $parent.intake.offers[offerAdminIndex].offerType !== '2'
          && $parent.intake.offers[offerAdminIndex].offerType !== '3'
        "
          type="text"
          placeholder="U-rendement"
          v-model="$parent.intakeAdmin.offers[offerAdminIndex].urendement"
        />
        <select
          name="profiles" id="profiles"
          v-model="$parent.intakeAdmin.offers[offerAdminIndex].profile"
        >
          <option value="" selected disabled>Beleggingsprofiel</option>
          <option v-for="(name, value) in profiles" :key="value" :value="value">
            Voorbeeld rendement {{name}}
          </option>
        </select>
        <select name="forhands" id="forhands"
          v-model="$parent.intakeAdmin.offers[offerAdminIndex].forehand"
        >
          <option value="" selected disabled>Rendementberekening</option>
          <option value="0" selected>Achteraf</option>
          <option value="1">Vooraf</option>
        </select>
        <input
          v-if="
            Number($parent.intake.offers[offerAdminIndex].offerType) === 1 // Lijfr. hoog
            || Number($parent.intake.offers[offerAdminIndex].offerType) === 4 // Netto lijfr. hoog
          "
          type="text" placeholder="Eerste uitkeringsbedrag (optioneel)"
          v-model="$parent.intakeAdmin.offers[offerAdminIndex].firstpayment"
        />
        <button @click="calculateOffer(offerAdminIndex);errorText = ''">
          Berekenen
        </button>
      </form>
    </template>
    <template v-else>
      <div
        class="form-error-atp warning"
        v-if="
         modelValue.offerType === '1'
         && Number($parent.intake.offers[offerAdminIndex].looptijd) >= 20
        "
      >
        <b>Let op:</b> Indicatie type 'Hoge aanvang' in combinatie met een looptijd van
        minimaal 20 jaar, bevat altijd tijdelijke lijfrentes.<br /><br />
        Daarom kan deze combinatie niet worden aangeboden voordat de AOW leeftijd is bereikt en/of
        voor sommige nabestaanden.
      </div>
      <div v-if="errorText" class="inset">
        <div class="row form-error-atp">
          <awesomeIcon icon="exclamation-circle" size="lg" style="margin-right: 10px;" />
          <b>Indicatie mislukt</b>
          <br /><br /><span v-html="errorText" />
        </div>
      </div>
      <form @submit.prevent class="inset">
        <textarea
          v-model="$parent.intakeAdmin.offers[offerAdminIndex].note"
          placeholder="Notitie..."
          rows="4"
        ></textarea>
        <customInput
          v-if="$parent.redo"
          v-model="modelValue.targetDate"
          type="date" label="Doeldatum"
          :minDatetime="new Date()"
          :maxDatetime="new Date(
              (new Date()
            ).setFullYear((new Date()).getFullYear() + 60))
          "
          :validation="['min', 'max']"
        />
        <button @click="offerAdminModal=false;">
          Notitie geven
        </button>
        <button @click="offerAdminModal=false;approveOffer(offerAdminIndex);">
          Indicatie afgeven
        </button>
        <button @click="recalcOffer(offerAdminIndex)" class="tertiary">
          Terug
        </button>
      </form>
    </template>
  </modalWindow>

</div>
</template>

<script>
/* eslint prefer-destructuring: ["error", {VariableDeclarator: {object: false}}] */
import { filter, findIndex, cloneDeep } from 'lodash-es';
import scoreWidget from '../ui/scoreMeter';
import projectWidget from './project';
import offerGoal from '../offers/intake/offerGoal';
import offerCosts from '../offers/intake/offerCosts';
import offerPort from '../offers/intake/offerPort';
import offerCover from '../offers/intake/offerCover';
import offerCourse from '../offers/intake/offerCourse';

export default {
  name: 'IntakeGoalPage',
  emits: ['update:model-value'],
  components: {
    scoreWidget,
    projectWidget,
    offerCover,
    offerGoal,
    offerCosts,
    offerCourse,
    offerPort,
  },
  data() {
    return {
      calling: false,
      callTimer: null,
      errorText: '',
      refreshSat: false,
      indicatieModal: false,
      berekenModal: false,
      studiedoelModal: false,
      meterModal: false,
      offerUserModal: false,
      offerDepositModal: false,
      offerAdminModal: false,
      offerAdminIndex: 0,
      maxOffertes: 3,
      pensioenLeeftijdModal: false,
      projection: [],
      previousCall: '',
      style: process.env.VUE_APP_STYLE,
      location: window.location,
    };
  },
  props: {
    modelValue: Object,
  },
  computed: {
    durationCalc() {
      if (Number(this.$parent.intake.offers[this.offerAdminIndex].offerType) === 3) {
        return this.formatPrice(
          Number(this.$parent.intakeAdmin.offers[
            this.offerAdminIndex
          ].calculation.looptijd.huidigprofiel),
          true,
        );
      }
      return this.formatPrice(
        Number(this.$parent.intake.offers[this.offerAdminIndex].looptijd),
        true,
      );
    },
    rendCalc() {
      return Number(this.modelValue.extrarendement)
        + (this.modelValue.vermogensbelasting === 'Yes' ? 120 : 0)
        + (this.modelValue.inflatie === 'Yes' ? 200 : 0);
    },
    returnMinPensionAge() {
      if (this.modelValue.box === '3') {
        if (Number(this.modelValue.leeftijd) > 18) {
          return Number(this.modelValue.leeftijd) + 1;
        }
        return 19;
      }
      if (Number(this.modelValue.leeftijd) > 45) {
        return Number(this.modelValue.leeftijd) + 1;
      }
      return 46;
    },
    value() {
      return this.modelValue;
    },
    startBedrag() {
      if (this.$parent.intakeAdmin.beleggen.brand === 'VMVB') {
        return 100000;
      }
      if (this.$parent.intakeAdmin.beleggen.brand === 'BVS') {
        return 250000;
      }
      if (this.$parent.intakeAdmin.beleggen.brand === 'OXBY') {
        return 15000;
      }
      return 10;
    },
    profiles() {
      if (this.style === 'db') {
        return [
          '0%',
          '1%',
          '2% - A',
          '3% - B',
          '4% - C',
          '5% - D',
          '6% - E',
          '7% - F',
          '8%',
          '9%',
          '10%',
        ];
      }
      if (this.style === 'ox') {
        return [
          '0%',
          '1%',
          '2%',
          '3%',
          '4%',
          '5% - Laag',
          '6% - Midden',
          '7% - Hoog',
          '8%',
          '9%',
          '10%',
        ];
      }
      return [
        '0%',
        '1%',
        '2%',
        '3%',
        '4% - Zeer defensief',
        '5% - Defensief',
        '6% - Neutraal',
        '7% - Offensief',
        '8% - Zeer offensief',
        '9%',
        '10%',
      ];
    },
    currentGoalOfferIndex() {
      return findIndex(
        this.currentGoalOffers,
        (o) => o.offerId === this.offerAdminIndex,
      );
    },
    currentGoalOffers() {
      if (this.modelValue.type === 'netto-lijfrente-uitkerend') {
        return filter(
          this.$parent.intake.offers,
          (o) => (o.offerType === '4' || o.offerType === '5') && !o.deleted,
        );
      }
      if (this.modelValue.type === 'gouden-handdruk-uitkerend') {
        return filter(
          this.$parent.intake.offers,
          (o) => (o.offerType === '2' || o.offerType === '3') && !o.deleted,
        );
      }
      // By default return Leefrente offers
      return filter(
        this.$parent.intake.offers,
        (o) => (o.offerType === '0' || o.offerType === '1') && !o.deleted,
      );
    },
    currentGoalOffersSelected() {
      if (this.modelValue.type === 'netto-lijfrente-uitkerend') {
        return filter(
          this.$parent.intake.offers,
          (o) => (o.offerType === '4' || o.offerType === '5') && o.selected,
        );
      }
      if (this.modelValue.type === 'gouden-handdruk-uitkerend') {
        return filter(
          this.$parent.intake.offers,
          (o) => (o.offerType === '2' || o.offerType === '3') && o.selected,
        );
      }
      // By default return Leefrente offers
      return filter(
        this.$parent.intake.offers,
        (o) => (o.offerType === '0' || o.offerType === '1') && o.selected,
      );
    },
    goalType() {
      if (this.modelValue.type === 'gouden-handdruk-uitkerend') {
        // eslint-disable-next-line
        this.modelValue.offerType = '2';
      } else if (this.modelValue.type === 'netto-lijfrente-uitkerend') {
        // eslint-disable-next-line
        this.modelValue.offerType = '4';
      } else if (this.modelValue.type === 'levensonderhoud'
        && this.modelValue.box === '1') {
        // eslint-disable-next-line
        this.modelValue.offerType = '1';
      }
      return this.modelValue.type;
    },
  },
  created() {
    if (this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
      if (
        this.modelValue.type === 'pensioen'
        || this.modelValue.type === 'gouden-handdruk-opbouwend'
        || this.modelValue.type === 'netto-lijfrente-opbouwend'
      ) {
        if (!this.modelValue.targetDate) {
          this.modelValue.looptijd = `${Number(this.modelValue.pensioenLeeftijd) - Number(this.modelValue.leeftijd)}`;
        }
        let doelvermogen = 0;
        for (let i = 0; i < Number(this.modelValue.uitkeringsPeriode); i += 1) {
          doelvermogen /= 1.04;
          doelvermogen += (Number(this.modelValue.doelAanvulling) * 12);
        }
        this.modelValue.doel = `${doelvermogen}`;
      } else if (
        this.modelValue.type === 'levensonderhoud'
        || this.modelValue.type === 'gouden-handdruk-uitkerend'
        || this.modelValue.type === 'netto-lijfrente-uitkerend'
      ) {
        this.modelValue.stortingenBedrag = `${-Number(this.modelValue.doelAanvulling)}`;
        this.modelValue.doel = '0';
      } else if (this.modelValue.type === 'studiekinderen' && !this.modelValue.targetDate) {
        if (Number(this.modelValue.leeftijdKindTot) <= Number(this.modelValue.leeftijdKind)) {
          this.modelValue.leeftijdKindTot = `${Number(this.modelValue.leeftijdKind) + 1}`;
        }
        if (!this.modelValue.targetDate) {
          this.modelValue.looptijd = `${Math.min(1, Number(this.modelValue.leeftijdKindTot) - Number(this.modelValue.leeftijdKind))}`;
        }
      }
      this.satCall();
    }
  },
  mounted() {
    if (this.$refs.focus) {
      this.$refs.focus.focusInput();
    }
    if (this.$parent.isOfferGoal && this.currentGoalOffers.length === 0 && !this.$parent.redo) {
      this.indicatieModal = true;
    }
  },
  watch: {
    modelValue: {
      handler() {
        // check if box is changed to 3
        if (this.modelValue.box === '3') {
          this.$parent.intake.transferData.overdrachten = [];
        }
        // Check if box is 1 and type is not 'bedrijfsrekening'
        if (this.modelValue.box === '1'
          && this.$parent.intake.rekeningData.type === 'Bedrijfsrekening') {
          this.$parent.intake.rekeningData.type = 'Particuliere rekening';
          for (let i = 0; i < this.$parent.intake.persoonsData; i += 1) {
            this.$parent.intake.persoonsData[i].type = null;
          }
        }
        if (this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
          if (this.modelValue.type === 'pensioen'
            || this.modelValue.type === 'gouden-handdruk-opbouwend'
            || this.modelValue.type === 'netto-lijfrente-opbouwend') {
            if (!this.modelValue.targetDate) {
              this.modelValue.looptijd = `${Number(this.modelValue.pensioenLeeftijd) - Number(this.modelValue.leeftijd)}`;
            }
            let doelvermogen = 0;
            for (let i = 0; i < Math.min(Number(this.modelValue.uitkeringsPeriode), 40); i += 1) {
              doelvermogen /= 1.04;
              doelvermogen += (Number(this.modelValue.doelAanvulling) * 12);
            }
            this.modelValue.doel = `${doelvermogen}`;
          } else if (this.modelValue.type === 'levensonderhoud'
            || this.modelValue.type === 'gouden-handdruk-uitkerend'
            || this.modelValue.type === 'netto-lijfrente-uitkerend') {
            this.modelValue.stortingenBedrag = `${-Number(this.modelValue.doelAanvulling)}`;
            this.modelValue.doel = '0';
          } else if (this.modelValue.type === 'studiekinderen' && !this.modelValue.targetDate) {
            if (Number(this.modelValue.leeftijdKindTot) <= Number(this.modelValue.leeftijdKind)) {
              this.modelValue.leeftijdKindTot = `${Number(this.modelValue.leeftijdKind) + 1}`;
            }
            if (!this.modelValue.targetDate) {
              this.modelValue.looptijd = `${Number(this.modelValue.leeftijdKindTot) - Number(this.modelValue.leeftijdKind)}`;
            }
          } else if (this.modelValue.type === 'vermogensopbouw') {
            this.berekenVermogensopbouw(true);
          }
          this.satCall();
        }
      },
      deep: true,
    },
  },
  methods: {
    filter,
    modusAlert() {
      this.$store.state.confirm.toggle({
        title: 'Actie mislukt',
        text: `
          Om wijzigingen in de vragenlijst door te voeren, dient u in de schrijfmodus te zitten.
          Klik hieronder op 'Activeer' om naar de schrijfmodus te gaan. Hou er rekening mee dat u
          gegevens kan overschrijven die de klant op dit moment aan het invullen is. Ga daarom snel
          uit de intake of schrijfmodus wanneer u klaar bent.
        `,
        confirmText: 'Activeer',
        cb: (confirmed) => {
          if (confirmed) {
            this.$parent.writeModus = true;
          }
        },
      });
    },
    offerProfile() {
      if (this.modelValue && this.modelValue.risk) {
        if (this.modelValue.risk === 'geen') {
          return 'Sparen';
        }
        if (this.modelValue.risk === 'zeer laag') {
          return 'A';
        }
        if (this.modelValue.risk === 'laag') {
          return 'B';
        }
        if (this.modelValue.risk === 'gemiddeld') {
          return 'C';
        }
        if (this.modelValue.risk === 'hoog') {
          return 'D';
        }
        if (this.modelValue.risk === 'zeer hoog' || this.modelValue.risk === 'extreem hoog') {
          return 'E';
        }
      }
      return 'C';
    },
    offerTypeName(offerType) {
      if (offerType === '1' || offerType === '4') {
        return 'hoge aanvang';
      }
      if (offerType === '2') {
        return 'vaste looptijd';
      }
      if (offerType === '3') {
        return 'vaste uitkering';
      }
      // offerType === '0' || offerType === '5'
      return 'normale aanvang';
    },
    openModal(modal) {
      if (modal === 'pensioenLeeftijdModal') {
        this.pensioenLeeftijdModal = true;
      }
      if (modal === 'bereken') {
        this.berekenModal = true;
      }
      if (modal === 'studieDoel') {
        this.studiedoelModal = true;
      }
      this.$nextTick(() => {
        if (this.$refs.fakeInputFocus) {
          this.$refs.fakeInputFocus.focusInput();
        }
      });
    },
    validateGoal() {
      this.$parent.intake.started = true;
      if (Number(this.$parent.role) !== 2 && this.modelValue.score < 40 && this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        this.$store.state.confirm.toggle({
          text: 'U heeft een laag haalbaarheidspercentage. Klik op de Doelmeter voor meer informatie.\n\nWilt u toch door?',
          cb: (confirmed) => {
            if (confirmed) {
              this.$parent.validationModal();
            }
          },
        });
      } else {
        this.$parent.validationModal();
      }
    },
    berekenAanvulling() {
      let doelvermogen = Number(this.modelValue.vermogen) + Number(this.$parent.portValue);
      let rendement = 1.04;
      const profile = this.$parent.toSatProfile(this.modelValue.risk);
      if (profile === 'DB6') {
        rendement = 1.06;
      } else if (profile === 'DB5') {
        rendement = 1.05;
      } else if (profile === 'DB4') {
        rendement = 1.04;
      } else if (profile === 'DB3') {
        rendement = 1.03;
      } else if (profile === 'DB2') {
        rendement = 1.016;
      } else if (profile === 'DB1') {
        rendement = 1.005;
      }
      let bedrag = this.modelValue.stortingenBedrag;
      if (this.modelValue.stortingenInterval === 'Per kwartaal') {
        bedrag /= 3;
      } else if (this.modelValue.stortingenInterval === 'Per jaar') {
        bedrag /= 12;
      }
      if (this.modelValue.targetDate) {
        for (
          let i = new Date();
          i < new Date(this.modelValue.targetDate);
          i.setMonth(i.getMonth() + 1)
        ) {
          doelvermogen += Number(bedrag);
          doelvermogen *= rendement ** (1 / 12);
        }
      } else {
        for (let i = 0; i < this.modelValue.looptijd; i += 1) {
          doelvermogen *= rendement;
          doelvermogen += (Number(bedrag) * 12);
        }
      }
      if (this.modelValue.type === 'pensioen'
        || this.modelValue.type === 'gouden-handdruk-opbouwend'
        || this.modelValue.type === 'netto-lijfrente-opbouwend') {
        this.modelValue.doelAanvulling = `${Math.ceil(this.PMT(
          0.04,
          Number(this.modelValue.uitkeringsPeriode),
          -doelvermogen,
          0,
          1,
        ) / 12)}`;
      } else {
        this.modelValue.doel = `${Math.round(doelvermogen)}`;
      }
      this.update();
    },
    berekenVermogensopbouw(input = false) {
      let doelvermogen = Number(this.modelValue.vermogen) + Number(this.$parent.portValue);
      const rendement = (Number(this.modelValue.extrarendement) / 100)
        + (this.modelValue.vermogensbelasting === 'Yes' ? 1.2 : 0)
        + (this.modelValue.inflatie === 'Yes' ? 2 : 0);

      let bedrag = this.modelValue.stortingenBedrag;
      if (this.modelValue.stortingenInterval === 'Per kwartaal') {
        bedrag /= 3;
      } else if (this.modelValue.stortingenInterval === 'Per jaar') {
        bedrag /= 12;
      }
      if (this.modelValue.targetDate) {
        for (
          let i = new Date();
          i < new Date(this.modelValue.targetDate);
          i.setMonth(i.getMonth() + 1)
        ) {
          doelvermogen += Number(bedrag);
          doelvermogen *= (1 + (((1 + (rendement / 100)) ** (1 / 12)) - 1));
        }
      } else {
        for (let i = 0; i < this.modelValue.looptijd; i += 1) {
          doelvermogen += (Number(bedrag) * 6);
          doelvermogen *= (1 + (rendement / 100));
          doelvermogen += (Number(bedrag) * 6);
        }
      }
      if (input) {
        this.modelValue.doel = `${Math.round(doelvermogen)}`;
        this.update();
      }
      return doelvermogen;
    },
    update() {
      this.$emit('update:model-value', this.value);
    },
    toSatInterval(value) {
      if (value === 'Per jaar') {
        return 'Y';
      }
      if (value === 'Per halfjaar') {
        return 'H';
      }
      if (value === 'Per kwartaal') {
        return 'Q';
      }
      return 'M';
    },
    intervalToYear(value) {
      if (value === 'Per jaar') {
        return 1;
      }
      if (value === 'Per halfjaar') {
        return 2;
      }
      if (value === 'Per kwartaal') {
        return 4;
      }
      return 12;
    },
    satCallReal() {
      if (!this.calling && this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        this.calling = true;
        const call = `${this.value.vermogen}#${this.value.doel}#
          ${this.value.targetDate}${this.value.looptijd}#${this.value.stortingenBedrag}#
          ${this.$parent.intakeAdmin.beleggen.profile}#${this.$parent.intakeAdmin.beleggen.maxProfile}#
          ${this.value.stortingenInterval}#${this.value.risk}#${this.$parent.intakeAdmin.beleggen.lifecycleDisabled}`;
        if (this.previousCall !== call) {
          this.previousCall = call;
          this.sdk.newSat(
            Number(this.value.vermogen) + Number(this.$parent.portValue),
            this.value.doel,
            this.value.targetDate ? null : this.value.looptijd,
            this.value.targetDate,
            Number(this.value.stortingenBedrag),
            this.toSatInterval(this.value.stortingenInterval),
            this.$parent.cashflowDate,
            0,
            this.toSatInterval(0),
            null,
            this.$parent.intakeAdmin.beleggen.profile
              ? this.$parent.toSatProfile2(this.$parent.intakeAdmin.beleggen.profile)
              : null,
            this.$parent.intakeAdmin.beleggen.maxProfile
              ? this.$parent.toSatProfile2(this.$parent.intakeAdmin.beleggen.maxProfile)
              : this.$parent.toSatProfile(this.value.risk),
            (response) => {
              if (response.status === 200) {
                this.modelValue.score = response.data.score;
                if (!this.$parent.intakeAdmin.beleggen.profile) {
                  this.modelValue.optimalProfile = response.data.pvvidata ? response.data.pvvidata[0].vProfile : '?';
                }
                this.projection = response.data.pvvidata;
                this.modelValue.hasToAcceptLowerScore = false;
                this.update();
                this.calling = false;
                if (this.refreshSat) {
                  this.refreshSat = false;
                  this.satCall();
                }
              } else {
                window.onbeforeunload = () => {};
                this.sdk.logout();
                window.location.reload();
              }
            },
            this.$parent.intakeAdmin.beleggen.lifecycleDisabled !== 'Yes',
          );
        } else {
          this.calling = false;
        }
      } else {
        this.refreshSat = true;
      }
    },
    satCall() {
      clearTimeout(this.callTimer);
      this.callTimer = setTimeout(this.satCallReal, 1000);
    },
    createOffer() {
      this.$store.state.intakeValidate = true;
      this.errorText = '';
      if (this.$parent.errors) {
        // eslint-disable-next-line
        alert('Indicatie aanvraag onjuist...');
      } else {
        const offer = {
          offerId: this.$parent.intake.offers.length,
          selected: false,
          selectedDate: '',
          deleted: false,
          offerDate: new Date().toISOString(),
          vermogen: this.modelValue.vermogen,
          offerType: this.modelValue.offerType,
          looptijd: this.modelValue.looptijd,
          stortingenInterval: this.modelValue.stortingenInterval,
          stortingenBedrag: this.modelValue.stortingenBedrag,
          nextOfKin: this.modelValue.nextOfKin,
          doelAanvulling: this.modelValue.offerType === '3' ? this.modelValue.doelAanvulling : '',
        };
        if (Number(this.$parent.role) === 2) {
          this.checkAtpOffer(offer);
        } else {
          this.indicatieModal = false;
          this.$parent.intake.offers.push(offer);
          this.$parent.storeIntake(this.$parent.intake.step);
        }
      }
    },
    checkAtpOffer(offer) {
      this.sdk.getReturnToday((response) => {
        const adminOfferObject = {
          profile: 4,
          urendement: response.data.return ? response.data.return : 2,
          forehand: '0',
          calculated: false,
          approved: false,
          tempStartDate: 0,
          note: '',
          user: this.$store.state.client,
          calculatedDate: '',
        };
        // figure out if its GH or LR for target amount
        let offerTargetAmount = adminOfferObject.firstpayment;
        if (offer.offerType === '3') {
          offerTargetAmount = offer.doelAanvulling;
        }
        // this function and result comes from the mixin
        this.sdk.offerCalc(
          offer.offerType,
          Number(offer.vermogen),
          adminOfferObject.profile,
          offer.looptijd,
          Number(adminOfferObject.urendement),
          adminOfferObject.forehand,
          offerTargetAmount ? Number(offerTargetAmount) : '',
          (offerResponse) => {
            if (offerResponse.status === 200) {
              adminOfferObject.calculation = cloneDeep(offerResponse.data);
              adminOfferObject.calculated = true;
              adminOfferObject.calculatedDate = new Date().toISOString();
              this.indicatieModal = false;
              this.$parent.intake.offers.push(offer);
              this.$parent.storeIntake(this.$parent.intake.step);
              if (!this.$parent.intakeAdmin.offers[offer.offerId]) {
                this.$parent.intakeAdmin.offers[offer.offerId] = adminOfferObject;
                this.offerAdminIndex = offer.offerId;

                this.storeAdmin();
                this.approveOffer(this.offerAdminIndex);
              }
            } else if (offerResponse.status === 410) {
              this.errorText = offerResponse.data.message;
            }
          },
        );
      });
    },
    createAdminOffer(index) {
      this.errorText = '';
      if (!this.$parent.intakeAdmin.offers[index]) {
        this.sdk.getReturnToday((response) => {
          this.$parent.intakeAdmin.offers[index] = {
            profile: 4,
            urendement: response.data.return ? response.data.return : 2,
            forehand: '0',
            calculated: false,
            approved: false,
            tempStartDate: 0,
            note: '',
            user: this.$store.state.client,
            calculatedDate: '',
          };
          this.storeAdmin();
          this.offerAdminIndex = index;
          this.offerAdminModal = true;
        });
      } else {
        this.offerAdminIndex = index;
        this.offerAdminModal = true;
      }
    },
    calculateOffer(index, overwrite = false) {
      if (this.$parent.intake.offers[index]) {
        // figure out if its GH or LR for target amount
        let offerTargetAmount = this.$parent.intakeAdmin.offers[index].firstpayment;
        if (this.$parent.intake.offers[index].offerType === '3') {
          offerTargetAmount = this.$parent.intake.offers[index].doelAanvulling;
        }
        this.sdk.offerCalc(
          this.$parent.intake.offers[index].offerType,
          Number(this.$parent.intake.offers[index].vermogen),
          this.$parent.intakeAdmin.offers[index].profile,
          this.$parent.intake.offers[index].looptijd,
          Number(this.$parent.intakeAdmin.offers[index].urendement),
          this.$parent.intakeAdmin.offers[index].forehand,
          offerTargetAmount ? Number(offerTargetAmount) : '',
          (response) => {
            if (response.status === 200) {
              this.$parent.intakeAdmin.offers[
                index
              ].calculation = cloneDeep(response.data);
              this.$parent.intakeAdmin.offers[index].calculated = true;
              this.$parent.intakeAdmin.offers[index].calculatedDate = new Date().toISOString();
              this.$parent.storeAdmin();
            } else if (response.status === 410) {
              this.errorText = response.data.message;
            }
          },
          overwrite,
        );
      }
    },
    deleteOffer(index) {
      this.$parent.intake.offers[index].deleted = true;
      this.$parent.storeIntake(this.$parent.intake.step);
    },
    recalcOffer(index) {
      this.$parent.intakeAdmin.offers[index].calculated = false;
      this.storeAdmin();
    },
    storeAdmin() {
      if (Number(this.$parent.role) === 2) {
        this.sdk.pushOffersIntake(
          this.$parent.id,
          JSON.stringify(this.$parent.intakeAdmin.offers),
          (response) => {
            if (response.status === 403) {
              this.$store.state.confirm.toggle({
                alert: true,
                text: 'U heeft geen toegang tot deze vragenlijst',
                cb: () => {},
              });
            }
          },
        );
      } else {
        this.$parent.storeAdmin();
      }
    },
    approveOffer(index) {
      this.$parent.intakeAdmin.offers[index].approved = true;
      this.storeAdmin();
    },
    writePayouts() {
      this.sdk.adminIntakePayouts(this.getQueryVariable('intake'), (response) => {
        if (response.status === 200) {
          // eslint-disable-next-line
          alert('De potjes zijn aan uitbetalingen tool toegevoegd.');
        } else {
          // eslint-disable-next-line
          alert('Het lukt niet de potjes aan uitbetalingen tool toe te voegen...');
        }
      });
    },
    selectOffer(index) {
      if (!this.$parent.redo) {
        this.modelValue.vermogen = this.$parent.intake.offers[index].vermogen;
      } else {
        this.modelValue.vermogen = '0';
      }
      this.modelValue.looptijd = this.$parent.intake.offers[index].looptijd;
      this.modelValue.stortingenInterval = this.$parent.intake.offers[index].stortingenInterval;
      if (
        `${this.$parent.intake.offers[index].offerType}` === '1'
        || `${this.$parent.intake.offers[index].offerType}` === '4'
      ) {
        this.modelValue.doelAanvulling = this.$parent.intakeAdmin.offers[
          index
        ].calculation.charts.chart2[0][2];
      } else if (
        `${this.$parent.intake.offers[index].offerType}` !== '0'
        && `${this.$parent.intake.offers[index].offerType}` !== '5'
      ) {
        this.modelValue.doelAanvulling = this.$parent.intakeAdmin.offers[
          index
        ].calculation.charts.chart1[0][2];
      } else {
        this.modelValue.doelAanvulling = this.$parent.intakeAdmin.offers[
          index
        ].calculation.charts.chart2[0][1];
      }
      if (this.modelValue.stortingenInterval === 'Per maand') {
        this.modelValue.doelAanvulling = Number(this.modelValue.doelAanvulling) / 12;
      } else if (this.modelValue.stortingenInterval === 'Per halfjaar') {
        this.modelValue.doelAanvulling = Number(this.modelValue.doelAanvulling) / 2;
      } else if (this.modelValue.stortingenInterval === 'Per kwartaal') {
        this.modelValue.doelAanvulling = Number(this.modelValue.doelAanvulling) / 4;
      }
      if (this.$parent.intake.offers[index].nextOfKin) {
        this.modelValue.nextOfKin = this.$parent.intake.offers[index].nextOfKin;
      }
      this.$parent.intake.offers[index].selected = true;
      this.$parent.intake.offers[index].selectedDate = new Date().toISOString();
      this.update();
      this.$parent.storeIntake(this.$parent.intake.step);
    },
    deSelectOffer(index) {
      this.$parent.intake.offers[index].selected = false;
      this.update();
      this.$parent.storeIntake(this.$parent.intake.step);
    },
  },
};
</script>

<style lang="scss" scoped>
  .form-error-atp {
    border-radius: 5px;
    padding: 10px;
    background-color: #d9544f71;
    color: #fff;
    display: block;
  }
  .warning {
      background-color: rgba(241, 249, 13, 0.373);
      color: #000;
      margin-bottom: 10px;
    }
  .chart {
    margin-top: 20px;
    padding: 20px;
  }
  .footer {
    background-color: $color-highlight;
    color: #1a3300;
    border-radius: $br;
    margin-top: 20px;
  }
  .disclaimer {
    padding: 10px;
    text-align: justify;
    font-size: .9em;
    color: rgba(0,0,0,0.5);
    @media #{$desktop} {
      margin-left: -10px;
      margin-right: -10px;
    }
  }
  .sliderinfo {
    position: absolute;
    top: 12px;
    left: 165px;
    color: $color-highlight;
  }
  .info-button {
    flex-grow: 1;
    min-height: 350px;
    &:hover {
      background-color: darken(#f7f8fa, 5%);
      cursor: pointer;
    }
  }

  .offer-menu {
    border-top: 1px solid #efecf3;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    button {
      margin: 10px;
    }
  }

  .goal-inputs {
    &.selected {
      display: none;
      & ~ .offer-container {
        margin-left: 0;
      }
    }
  }

  @keyframes fadeInOpacity {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  .fade-in {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: .5s;
  }

  .offer-container {
    flex-grow: 1;
    .empty {
      border: 2px dashed $color-lightgrey2;
      position: relative;
      border-radius: $br;
      margin: 2px;
      text-align: center;
      padding: 20px;
    }
    .admin {
      text-align: right;
      opacity: .5;
      margin-top: 5px;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
    .offer {
      margin-top: 10px;
      margin-bottom: 10px;
      position: relative;
      &:first-child {
        margin-top:0;
      }
      .offer-box {
        padding: 15px;
        background-color: $color-grey;
        border-radius: 4px;
        position: relative;
        .menu {
          @media #{$desktop} {
            position: absolute;
            bottom: 13px;
            right: 13px;
            button {
              margin-left: 10px;
            }
          }
          @media #{$mobile} {
            margin-top: 10px;
            button {
              margin-right: 10px;
            }
          }
        }
        h2 svg {
          color: #6c0;
        }
        .date {
          position: absolute;
          top: 12px;
          right: 15px;
        }
        .faded {
          opacity: 0.7;
        }
        .status-text {
          display: block;
        }
      }
    }
  }
</style>

<style lang="scss">
  .boxradio .info {
    width: calc(100% - 30px) !important;
  }
  .boxradio label {
    float: left !important;
    @media #{$desktop} {
      margin-left: 10px !important;
    }
  }
</style>
